/**
 * Forces a function call into the next frame.
 */
export function forceNextFrame(callback: Function, params: any[] = []) {
  // Double raF is the best method we have of forcing the next frame.
  // It's not 100% effective, but works the vast majority of the time.
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      callback(...params);
    });
  });
}
